module.exports = __webpack_public_path__ + "static/media/lightbulb-on.dc3fe53d.svg";